/**
 * 소셜 로그인 제공자.
 *
 * 코드값(`GOOGL` / `NAVER` / `KAKAO`)은 **DB 값**이다 — `MC_USER.F_SITE`.
 * 회원 식별자는 `F_SITE` + `F_ID` 조합이라 코드를 바꾸면 기존 회원과 끊어진다.
 *
 * ⚠️ 소셜 회원번호는 OAuth 앱 단위로 발급된다. 앱(client_id)을 바꾸면 같은 계정도
 *   새 사람으로 잡힌다. 기존 회원 승계 문제는 `history.md` 8절 참고.
 */

import type { Site } from '@/types/common.ts';

export interface SocialProvider {
  site: Site;
  /** 마이페이지 배지 문구 */
  label: string;
  /** 배지 아이콘 */
  icon: string;
  /** 아이콘 뒤 배경색. 아이콘 자체에 배경이 있으면 지정하지 않는다(카카오). */
  background?: string;
}

/** 시안 `_mypage.html` 의 배지. 배경색은 시안 인라인 스타일을 따랐다. */
export const SOCIAL_PROVIDERS: Record<Site, SocialProvider> = {
  GOOGL: {
    site: 'GOOGL',
    label: '구글 로그인',
    icon: '/images/google-my.png',
    background: '#FFFFFF',
  },
  NAVER: {
    site: 'NAVER',
    label: '네이버 로그인',
    icon: '/images/naver-my.png',
    background: '#03C75A',
  },
  KAKAO: {
    site: 'KAKAO',
    label: '카카오 로그인',
    icon: '/images/kakao-my.png',
  },
};

/**
 * 회원 등급 표기 (시안 `_mypage.html` 의 `배지 · 준회원`).
 *
 * ⚠️ 고정 문자열이다. `MC_USER` 에 등급 컬럼이 없어 모든 회원이 '준회원' 으로
 * 보인다. 등급 체계가 생기면 회원 정보에서 받아 써야 한다.
 */
export const MEMBER_GRADE_LABEL = '준회원';
